import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

type LabelValueProps = {
  readonly label: ReactNode;
  readonly value?: ReactNode;
  readonly color?: 'default' | 'brand';
};

export const LabelValue = ({ label, value, color = 'default' }: LabelValueProps) => {
  const labelColor = color === 'brand' ? 'textTertiaryOnBrand' : 'textTertiary';
  const valueColor = color === 'brand' ? 'textSecondaryOnBrand' : 'textPrimary';

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Typography variant="labelLight" color={labelColor}>
        {label}
      </Typography>
      {typeof value === 'object' ? (
        value
      ) : (
        <Typography variant="labelLight" color={valueColor}>
          {value ?? '-'}
        </Typography>
      )}
    </Box>
  );
};
